export const getImageUrlAdminToken = (url) => {
  // console.log('getImageUrlAdminToken', url);
    const token = localStorage.getItem('cookies');
    if (!url) return '';
    return `${url}?token=${token}`;
  };
  
  